var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),(_vm.isCover&&_vm.showCover)?_c('div',{attrs:{"id":"Cover"}},[_c('img',{attrs:{"id":"CoverImg","src":require("./assets/roate.png"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"CoverTip"},[_vm._v("为了您的良好体验，在非课程内容页面下，请您将手机/平板竖屏操作")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b02ebd8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 